module.exports = __webpack_public_path__ + "static/images/dialog-gift-btn-ok.13e1ea6.png";